import { connect } from 'react-redux';
import * as R from 'ramda';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { setBedroomsCount } from '../../actions/filters';
import { FilterBedrooms, IFilterBedroomsProps } from '../../components/FilterBedrooms';

type TFilterRoomTypeStateProps = Pick<IFilterBedroomsProps, 'value'>;
type TFilterRoomTypeDispatchProps = Pick<IFilterBedroomsProps, 'onChange'>;

export function mapStateToProps(state: IReduxState): TFilterRoomTypeStateProps {
  const { jsonQuery } = state.filters;

  return {
    value: R.pathOr(null, ['bedroom_total', 'value', 'gte'], jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterRoomTypeDispatchProps {
  return {
    onChange: (bedroomsCount: number) => dispatch(setBedroomsCount(bedroomsCount)),
  };
}

export const FilterBedroomsContainer = connect(mapStateToProps, mapDispatchToProps)(FilterBedrooms);
